import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { RefreshCw } from 'lucide-react';
import { apiClient } from '../../utils/apiHelper';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const BankBalance = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => { fetchBalance(); }, []);

  const fetchBalance = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${API_URL}/api/accounts/bank-balance`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (response.status === 200 || response.data) {
        setData(await response.json());
      } else {
        console.error('Failed to fetch bank balance');
      }
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6">
      <Card>
        <CardHeader className="flex flex-row items-center justify-between">
          <CardTitle>Bank Balance</CardTitle>
          <Button onClick={fetchBalance} disabled={loading}>
            <RefreshCw className="w-4 h-4 mr-2" />
            {loading ? 'Refreshing...' : 'Refresh'}
          </Button>
        </CardHeader>
        <CardContent>
          {data && (
            <div className="space-y-4">
              <div className="p-6 bg-gradient-to-r from-blue-50 to-blue-100 rounded-lg">
                <p className="text-sm text-gray-600 mb-2">Total Bank Balance</p>
                <p className="text-4xl font-bold text-blue-600">₹{data.total_balance.toFixed(2)}</p>
              </div>
              
              {data.banks && data.banks.length > 0 && (
                <div>
                  <h3 className="text-lg font-semibold mb-3">Bank Accounts</h3>
                  <table className="w-full border-collapse">
                    <thead>
                      <tr className="border-b">
                        <th className="text-left p-3">Bank Name</th>
                        <th className="text-left p-3">Account Number</th>
                        <th className="text-left p-3">Account Type</th>
                        <th className="text-left p-3">Current Balance</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.banks.map((bank) => (
                        <tr key={bank.id} className="border-b hover:bg-gray-50">
                          <td className="p-3 font-medium">{bank.bank_name}</td>
                          <td className="p-3">{bank.account_number}</td>
                          <td className="p-3">{bank.account_type}</td>
                          <td className="p-3 font-semibold text-blue-600">₹{bank.current_balance.toFixed(2)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
              
              {(!data.banks || data.banks.length === 0) && (
                <p className="text-center text-gray-500 py-4">No bank accounts found. Please create a bank account first.</p>
              )}
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default BankBalance;